// src/pages/InventoryPage.js
import React, { useEffect, useState } from "react";
import InventoryDesktop from "./InventoryDesktop";
import InventoryMobile from "./InventoryMobile";

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < breakpoint);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);

  return isMobile;
}

export default function InventoryPage() {
  const isMobile = useIsMobile(768);
  return isMobile ? <InventoryMobile /> : <InventoryDesktop />;
}
